import { HelpParameters, Help, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_2Screen } from "../SlotGameType1_2Screen";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";
import { AudioManager} from "../../AudioManager";
import { Rect } from "../.././MyHelpers";
import { ResourceManager } from "../../ResourceManager/ResourceManager";
import {  FontResource } from "../../ResourceManager/FontResource";
import { WinNumberLinesFactory } from "../WinLines/WinNumberLinesFactory";
// namespace SlotGames {

    export class LavaLand_2Screen extends SlotGameType1_2Screen {

        
        //protected panelFactory: IPanelFactory = new LavaLandPanelFactory();
        protected override helpFactory: IHelpFactory = new LavaLandHelpFactory();
        //LED COLOR
        protected override ColorLed: string = "137,0,0\n";


        //SEND COLOR 
        protected override color: RewardColor =
            {
                color: "white",
                coloroutherStroke: "black",
                colorinnerStroke: "red",
            }

        constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
            super(multigameParams, initData, "LavaLand");

            this.spinnableReelsParams.topBorderWidth = 10;
            this.spinnableReelsParams.bottomBorderWidth = 10;
        }
    }
    //Panel Colorized
    class LavaLandPanelFactory implements IPanelFactory {
        public CreateNewPanel(params: PanelParams): Panel {
            return new LavaLandPanel(params);
        }
    }

    class LavaLandPanel extends Panel {
        protected override ButtonBackground(): ButtonColors {
            let color: ButtonColors = {
                backgroundButtonColor: "linear-gradient(rgb(38, 1, 1),rgb(89, 3, 3), rgb(140, 4, 4),rgb(89, 3, 3),rgb(38, 1, 1)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
                linearColor: "linear-gradient(to left , transparent, DarkOrange,transparent ) 0 10 100%",
            };

            return color;
        }
    }


    //Help Colorized
    class LavaLandHelpFactory implements IHelpFactory {
        public CreateNewHelp(params: HelpParameters): Help {
            return new LavaLandHelp(params);
        }
    }

    class LavaLandHelp extends Help {
        protected override BackgroundPanel(): HelpPanelColor {
            let color: HelpPanelColor = {
                backgroundPanelColor: "linear-gradient(rgb(38, 1, 1),rgb(89, 3, 3), rgb(140, 4, 4),rgb(89, 3, 3),rgb(38, 1, 1)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            };

            return color;
        }
    }

// }